import type { ReactNode } from 'react';

export const symbol_arrow_warm_up: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M458.5-468.63Q450-477.25 450-490v-276L263-579q-9 9-21 9t-21-9q-9-9-9-21t9-21l238-238q5-5 10.13-7 5.14-2 11-2 5.87 0 10.87 2 5 2 10 7l238 238q9 9 9 21.16t-8.61 21Q730-570 717.9-570q-12.1 0-20.9-9L510-766v276q0 12.75-8.68 21.37-8.67 8.63-21.5 8.63-12.82 0-21.32-8.63Zm0 200Q450-277.25 450-290v-80q0-12.75 8.68-21.38 8.67-8.62 21.5-8.62 12.82 0 21.32 8.62 8.5 8.63 8.5 21.38v80q0 12.75-8.68 21.37-8.67 8.63-21.5 8.63-12.82 0-21.32-8.63Zm0 180Q450-97.25 450-110v-60q0-12.75 8.68-21.38 8.67-8.62 21.5-8.62 12.82 0 21.32 8.62 8.5 8.63 8.5 21.38v60q0 12.75-8.68 21.37-8.67 8.63-21.5 8.63-12.82 0-21.32-8.63Z"
		/>
	</svg>
);
